import { IconDownload, IconInformation } from '../../../assets/DesignSystem/SVGComponents';
import './NudosLinkTypeButton.scss';

/**
 * @property { string } text - The text to show in the link like button
 * @property { () => void } handleClickCallback - The calback to execute upon clicking the button
 * @property { string } customClassname - A classname for custom styles
 * @property { JSX.Element } customIcon - An icon to use instead of the default "information" icon
 */
const NudosLinkTypeButton = ({
  text,
  handleClickCallback,
  customClassname,
  specialIcon,
  customIcon,
  hideIcon,
  isDisabled
}: {
  text: string;
  handleClickCallback: () => void;
  customClassname?: string;
  specialIcon?: 'download';
  customIcon?: JSX.Element;
  hideIcon?: boolean;
  isDisabled?: boolean;
}) => {
  const disabledStyles = isDisabled ? 'disabled' : '';
  const onClickCallback = isDisabled ? undefined : handleClickCallback;

  const getIcon = () => {
    switch (specialIcon) {
      case 'download':
        return <IconDownload className="downloadIcon" />;
      default:
        return <IconInformation />;
    }
  };

  const icon = getIcon();

  return (
    <div className={`nudosLinkTypeButton ${customClassname || ''} ${disabledStyles}`} onClick={onClickCallback}>
      {!hideIcon && <div className="icon">{customIcon || icon}</div>}
      <div className="text">{text}</div>
    </div>
  );
};

export default NudosLinkTypeButton;
